import React from 'react'
import {withRouter} from 'react-router-dom'
import {Space} from 'antd'
import {BlackListProvider} from "./store/useBlackListContext"
import BlackListSearch from "./component/BlackListSearch"
import BlackListTable from "./component/BlackListTable"

const BlackList = () => {
  return (
      <div>
        <BlackListProvider>
          <Space direction={"vertical"} style={{width:"100%"}}>
            <BlackListSearch/>
            <BlackListTable/>
          </Space>
        </BlackListProvider>
      </div>
  )
}

export default withRouter(BlackList)



// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/index.js